module.exports = __webpack_public_path__ + "img/close.e9449978.svg";